var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeedUserA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=\xED\x94\xBC\xEB\x93\x9C\xEB\xB0\xB1, \xEC\x83\x81\xED\x83\x9C=hover"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17 7.5V3C17 1.89543 16.1046 1 15 1H3C1.89543 1 1 1.89543 1 3V10.8261C1 11.9307 1.89543 12.8261 3 12.8261H4.56522V17L8.73913 12.8261H9M14.163 15.3913L16.7717 18V15.3913H17C18.1046 15.3913 19 14.4959 19 13.3913V10C19 8.89543 18.1046 8 17 8H11C9.89543 8 9 8.89543 9 10V13.3913C9 14.4959 9.89543 15.3913 11 15.3913H14.163Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeedUserA);
export default __webpack_public_path__ + "static/media/Icon_feed_user_a.e6004d2e8d6b50f847aa86d30a501d17.svg";
export { ForwardRef as ReactComponent };